/**
 * 챕터 목록을 마크다운 형식으로 포맷팅하는 함수
 * @param {Array} chapters - 챕터 배열
 * @returns {string} - 포맷팅된 마크다운 문자열
 */
export const formatChapters = (chapters) => {
  if (!chapters || !Array.isArray(chapters)) return '';
  
  let content = '## 목차\n\n';
  
  // 목차 생성 (스크롤 이동용)
  chapters.forEach((chapter, index) => {
    if (chapter && chapter.title) {
      content += `${index + 1}. [${chapter.title}](#chapter-${index + 1}) ${chapter.startTime || ''}\n`;
    }
  });
  
  content += '\n---\n\n';
  
  // 챕터 내용 생성 (YouTube 플레이어 이동용)
  chapters.forEach((chapter, index) => {
    if (chapter && chapter.title) {
      content += `### ${index + 1}. ${chapter.title} ${chapter.startTime ? `(${chapter.startTime})` : ''}\n\n`;
      if (chapter.bullets && Array.isArray(chapter.bullets)) {
        chapter.bullets.forEach(bullet => {
          content += `- ${bullet}\n`;
        });
        content += '\n';
      }
    }
  });
  
  return content;
};

/**
 * 자막 길이를 기반으로 예상 청크 개수를 계산하는 함수
 * @param {string} transcript - 자막 텍스트
 * @returns {number} - 예상 청크 개수
 */
export const calculateExpectedChunks = (transcript) => {
  if (!transcript || typeof transcript !== 'string') return 4; // 기본값
  
  const charCount = transcript.length;
  // 백엔드와 동일한 로직: 한글 기준 1글자 ≈ 2토큰, max_tokens=10000이므로 대략 5000자당 1청크
  const chunksCount = Math.ceil(charCount / 5000);
  // 최소 2개, 최대 15개로 제한 (백엔드와 동일)
  return Math.min(Math.max(chunksCount, 2), 15);
}; 